import React, { useState } from "react";
import SearchTab from "./tabs/SearchTab";

type Tab = "search";

const TABS: { id: Tab; label: string }[] = [
  { id: "search", label: "Search" },
];

const HomePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>("search");

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center gap-3 px-6 h-[78px] border-b border-krule bg-white shrink-0">
        <div>
          <h2 className="text-xl font-light tracking-tight text-ink">Full Text Search</h2>
          <p className="text-xs font-mono text-kslate mt-0.5">Test indexing-worker endpoints</p>
        </div>
      </div>

      {/* Tab bar */}
      <div className="shrink-0 border-b border-krule px-6 bg-white">
        <div className="flex -mb-px">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.id
                  ? "border-kamber text-ink"
                  : "border-transparent text-kslate hover:text-inklight hover:border-krule"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Scrollable tab content */}
      <div className="flex-1 min-h-0 overflow-y-auto px-6 py-6">
        {activeTab === "search" && <SearchTab />}
      </div>
    </div>
  );
};

export default HomePage;
